import {Dispatch} from "redux";
import {
    CALENDAR_COMPLIANCE_STORE,
    CalendarComplianceDispatchTypes
} from "./CalendarComplianceActionTypes";
import {defaultCalendarComplianceState} from "../reducer/CalendarComplianceReducer";
import {CalendarComplianceRequest} from "../../../api/grs";
import moment from "moment";
import GrsApiModel from "../../apiModel/GrsApiModel";
import {postDataToServiceWithRedux} from "store-fetch-wrappers";
import {statusCodeCallback} from "../../helpers/storeHelpers";

export const nullifyCalendarComplianceStore = () => {
    return async (dispatch: Dispatch<CalendarComplianceDispatchTypes>) => {
        dispatch({
            ...defaultCalendarComplianceState,
            type: CALENDAR_COMPLIANCE_STORE.SUCCESS
        });
    };
};

export const getCalendarCompliance = () => {
    return async (dispatch: Dispatch<CalendarComplianceDispatchTypes>) => {
        const now = moment().startOf("day");
        const request: CalendarComplianceRequest = {
            startDateInclusive: now.clone().unix(),
            endDateExclusive: now.clone().add(3, "day").unix()
        };
        try {
            return await postDataToServiceWithRedux(
                CALENDAR_COMPLIANCE_STORE,
                dispatch,
                () => GrsApiModel.getCalendarApi().listCalendarCompliance(request),
                statusCodeCallback
            );
        } catch (e: any) {
            dispatch({
                type: CALENDAR_COMPLIANCE_STORE.ERROR,
                loading: false,
                error: e
            });
        }
    };
};
